import React from 'react';
import { Icon } from 'semantic-ui-react';
import Events from '../hooks/events';

const AnnouncementDismiss = () => {
  const hide = Events.useCloseAnnouncements('all');
  return (
    <Icon
      name="close"
      size="small"
      className="absolute f-12 right-0"
      onClick={() => hide({ date: Date.now() })}
    />
  );
};

export default AnnouncementDismiss;
